import React, { useContext } from "react";
import { ContentCard } from "../../components/ContentCard";
import { Button } from "@mui/material";
import { DesignationType } from "common/types/comparableFields.types";
import { LinkForButton } from "../../components/links/LinkForButton";
import { useRouteQuery, useUpdateQueryParam } from "../../hooks/router.hooks";
import { PropertyCreationContext } from "./PropertyCreationProvider";
import { useTranslation } from "react-i18next";
import { PropertyTypeSelector } from "../../components/propertyCRUD/PropertyTypeSelector";

interface PropertyTypeSelectRouteProps {}

export const PropertyTypeSelectRoute: React.FC<
  PropertyTypeSelectRouteProps
> = () => {
  const { t } = useTranslation();
  const query = useRouteQuery();
  const designationType = query.get("type") as DesignationType;
  const propertyId = query.get("propertyId");

  const [propertyType, setPropertyType] = React.useState<DesignationType>(
    designationType ?? DesignationType.ResidentialApartments
  );

  const { fromLead } = useContext(PropertyCreationContext);
  const { getUpdatedQueryParam } = useUpdateQueryParam();

  return (
    <div>
      <ContentCard title={t("propertyCreation.type.selectPropertyType")}>
        <div
          style={{
            maxWidth: "600px",
            margin: "0 auto",
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            gap: "40px",
          }}
        >
          <PropertyTypeSelector
            selectedType={propertyType}
            onChange={setPropertyType}
          />

          <LinkForButton
            to={
              !!fromLead
                ? {
                    pathname: "../details",
                    search: getUpdatedQueryParam([
                      { paramName: "type", newValue: propertyType },
                    ]).search,
                  }
                : `/properties/${
                    !!propertyId ? propertyId : "create"
                  }/details?type=${propertyType}`
            }
          >
            <Button variant="contained" style={{ width: "250px" }}>
              {t("common.continue")}
            </Button>
          </LinkForButton>
        </div>
      </ContentCard>
    </div>
  );
};
